/// <reference path="../vendors/intact/vue.js" />

const tableAccordion = {
    props: {
        records: {
            type: Array,
            default: []
        }
    },
    data: function () {
        return {
            $this: null,
        }
    },
    template: `
        <div class="b-table-accordion" v-if="records.length">
            <template v-for="(value, i) in records[0].values">
                <div class="b-table-accordion__head">
                    <div class="b-table-accordion__row">
                        <div class="b-table-accordion__col" v-if="records[0].label">{{records[0].label}}</div>
                        <div class="b-table-accordion__col" v-if="records[0].values">{{records[0].values[i]}}</div>
                    </div>
                </div>
                <div class="b-table-accordion__cont">
                    <div class="b-table-accordion__row" v-for="item in records.slice(1)">
                        <div class="b-table-accordion__col">{{item.label}}</div>
                        <div class="b-table-accordion__col">{{item.values[i]}}</div>
                    </div>
                </div>
            </template>
        </div>
    `,
    mounted: function () {
        this.$this = jQuery(this.$el);

        this._iniAccordion()
    },
    methods: {
        _iniAccordion() {
            this.$this.accordionSection({
                header: '.b-table-accordion__head'
            })
        }
    },
    computed: {
    },
    watch: {
    }
};
